import { render, staticRenderFns } from "./alert-beta-feature.vue?vue&type=template&id=33d60378&scoped=true&"
import script from "./alert-beta-feature.vue?vue&type=script&lang=js&"
export * from "./alert-beta-feature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d60378",
  null
  
)

export default component.exports